module.exports = __webpack_public_path__ + "static/media/avatar.c41eeb73.jpeg";